import { Injectable } from '@angular/core';
import { AlertController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AlertMessageService{
  constructor(
    private alertController?: AlertController,
    private translate?: TranslateService,
  ) {
  }

  showError(text?) {
    if (!text) {
      text = 'Error Empty';
    }
    let alert = this.alertController.create({
      message: `<img src="assets/images/sf-mola-mola.svg" width="40%" height="40%" />` +
        `<h6 style="color:#808080;"><b>` + `Error` + `</b></h6>` +
        `<h6 style="color:#808080;">` + this.translate.instant(text) + `</h6>`,
      buttons: ["OK"]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pagebuilder/services/helper/alert-message.service.ts